import i18n from 'i18n-js';

export const bytesToView = (bytes: number) => {
  if (!bytes) {
    return `${0} ${i18n.t('bytes')}`;
  }
  const kb = bytes / 1024;
  if (kb < 1) {
    return `${bytes.toFixed(2)} ${i18n.t('bytes')}`;
  }
  const mb = kb / 1024;
  if (mb < 1) {
    return `${kb.toFixed(2)} ${i18n.t('KB')}`;
  }
  const gb = mb / 1024;
  if (gb < 1) {
    return `${mb.toFixed(2)} ${i18n.t('MB')}`;
  }

  return `${gb.toFixed(2)} ${i18n.t('GB')}`;
};

export const secondsToView = (seconds: number) => {
  if (!seconds) {
    return `${0} ${i18n.t('sec')}`;
  }
  const min = seconds / 60;
  if (min < 1) {
    return `${seconds.toFixed(0)} ${i18n.t('sec')}`;
  }
  const h = min / 60;
  if (h < 1) {
    return `${min.toFixed(0)} ${i18n.t('min')}`;
  }
  const d = h / 24;
  if (d < 1) {
    return `${h.toFixed(0)} ${i18n.t('h')}`;
  }

  return `${d.toFixed(0)} ${i18n.t(d.toFixed(0) > 1 ? 'days' : 'day')}`;
};

export const secondsToHours = (seconds: number) => `${Math.round(Math.abs(seconds) / 3600)}${i18n.t('h')}`;

export const interpolate = (inputRange: number[], outputRange: number[], y: number) => {
  const index = inputRange.findIndex((value, i, arr) => y < value || i === arr.length - 1);
  if (index === 0) {
    return outputRange[0];
  }
  const inputMin = inputRange[index - 1];
  const inputMax = inputRange[index];
  const outputMin = outputRange[index - 1];
  const outputMax = outputRange[index];

  const ratio = (y - inputMin) / (inputMax - inputMin);
  const result = outputMin + ratio * (outputMax - outputMin);
  return result;
};

export const formatOEENumber = (number: number) => {
  if (number < 100) {
    return (Math.round(number * 10) / 10).toFixed(1);
  }
  return Math.round(number);
};

export const formatOEEPercent = (ratio: number): string =>
  `${String(formatOEENumber((ratio || 0) * 100)).replace('.', ',')}%`;

export const calculatePercentage = (value: number, maxValue: number) => {
  if (maxValue <= 0) return 0;
  return Math.min((value / maxValue) * 100, 100);
};
